import LocalizedStrings from "react-localization";

if (!window.paymentLocalizedStrings) {
  const localizedStrings = new LocalizedStrings({
    en: {

      title: "Payment",
      get_credit: "Get $15 Credit",
      credit: "$15 Credit",
      bind_credit_card: "Get $15 credit immediately by binding your credit card.",
        phone_number_is_required: "Phone number is required",
        phone_number_is_invalid: "Phone number is invalid",
        email_is_required: "Email is required",
        email_is_invalid: "Email is invalid",
        verify_code_is_required: "Verify code is required",
        failed_to_create_payment_method: "Failed to create payment method",
        failed_to_load_user_info: "Failed to load user info",
        failed_to_get_products: "Failed to get products",
        failed_to_get_pending_items: "Failed to get pending items",
        failed_to_create_customer_portal: "Failed to create customer portal",
        failed_to_subscribe_plan: "Failed to subscribe plan",
        send_verification_code: "Send verification code",
        send: "Send",
        input_verification_code: "Input verification code",
        verify: "Verify",
        email: "Email",
        name: "Name",
        credit_card: "Credit Card",
        subscribe: "Subscribe",
        resume: "Resume Subscription",
        renew: "Renew Subscription",
        loading_products: "Loading products...",
        products: "Products",
        price_per_unit: "Price per unit",
        loading_invoices: "Loading invoices...",
        invoices: "Invoices",
        date: "Date",
        amount: "Amount",
        quantity: "Quantity",
        status: "Status",
        paid: "Paid",
        unpaid: "Unpaid",
        payment_method: "Payment Method",
        invoice: "Invoice",
        item: "Item",
        download_invoice_pdf: "Download Invoice PDF",
        no_products: "No products",
        no_products_description: "No products available",
        no_invoices: "No invoices",
        no_invoices_description: "No invoices available",
        failed_to_create_checkout_session: "Failed to create checkout session",
        failed_to_generate_invoice: "Failed to generate invoice",
        waiting_for_payment: "Waiting for payment...",
        created_at: "Created At: ",
        balance: "Balance: ",
        total: "Total: ",
        remaining: "Remaining: ",
        card_not_found: "Card not found",
        back: "Back",
        next: "Next",
        close: "Close",
        cancel: "Cancel",
        cancel_subscription: "Cancel Subscription",
        save: "Save",
        check_payment_configuration: "Check payment configuration",
        cancel_dialog: {
          title: "Cancel Subscription Confirmation",
          description: "Canceling your subscription will only make some PlexiMail features unavailable. Do you still want to cancel?",
          confirm_label: "",
          confirm_checkbox: "I understand that cancelling my subscription will make some PlexiMail features unavailable.",
          back: "Back",
          cancel: "Yes, Cancel"
        },
        add_payment_dialog: {
          title: "Add Payment Method",
          description: {
            line1: 'To continue to use PlexiSign after your trial credit has been used add a valid method of payment.',
            line2: 'PlexiSign.net will charge your method of payment for any billing amount from the previous month.',
            line3: 'If no charges were incurred, no billing will take place.'
          },
          back: "Back",
          add_now: "Add Now",
          add_later: "Add Later",
        },
        subscribe_title: "PlexiSign",
        auto_renew_title: "Auto-Renew",
        auto_renew_description: "Automatically renew your subscription at the end of the billing cycle.",
        cancelled_description: "Your subscription will been canceled at the end of the billing cycle.",
        payment_title: "Payment",
        manage: "Manage",
        loading_subscription: "Loading subscription ...",
        check_payment_config: "Check subscription status ...",
        verify_phone_number: "Verify phone number",
        create_customer: "Add Payment Method",
        create_subscription: "Subscribe PlexiSign",
        manage_subscription: "Manage Subscription",
        manage_payment: "Manage Payment",
        view_invoice_history: "Invoice History",
        view_invoice: "Invoice Details",
        invoice_preview: "Invoice Preview",
        update: "Update",
        save_updates: "Save Updates",
        prices: "Prices",
        usage_for_billing_cycle: "Usage for the current billing cycle",
        usage_for_trail_user: "Usage for the trial user",
        loading_usage: "Loading usage...",
        usage: "Usage",
        regionNameMap: {
          east_asia: "East Asia",
          south_asia: "South Asia",
          latin_america: "Latin America",
          southeast_asia: "Southeast Asia",
          africa: "Africa (excluding South Africa)",
          middle_east: "Middle East",
          eastern_europe: "Eastern Europe ((non-EU Eastern Europe))",
          aus_nz: "Australia and New Zealand",
          outliers: "Outliers",
          north_america: "North America",
          eu: "EU (EU countries + UK)"
        },

        countryNameMap: {
          // east_asia
          CN: "China", // China
          TW: "Taiwan", // Taiwan
          // south_asia
          AF: "Afghanistan", // Afghanistan
          BD: "Bangladesh", // Bangladesh
          BT: "Bhutan", // Bhutan
          IN: "India", // India
          MV: "Maldives", // Maldives
          NP: "Nepal", // Nepal
          PK: "Pakistan", // Pakistan
          LK: "Sri Lanka", // Sri Lanka
          // latin_america
          AR: "Argentina", // Argentina
          BS: "Bahamas", // Bahamas
          BB: "Barbados", // Barbados
          BZ: "Belize", // Belize
          BO: "Bolivia", // Bolivia
          BR: "Brazil", // Brazil
          CL: "Chile", // Chile
          CO: "Colombia", // Colombia
          CR: "Costa Rica", // Costa Rica
          CU: "Cuba", // Cuba
          DM: "Dominica", // Dominica
          DO: "Dominican Republic", // Dominican Republic
          EC: "Ecuador", // Ecuador
          SV: "El Salvador", // El Salvador
          GD: "Grenada", // Grenada
          GT: "Guatemala", // Guatemala
          GY: "Guyana", // Guyana
          HT: "Haiti", // Haiti
          HN: "Honduras", // Honduras
          JM: "Jamaica", // Jamaica
          MX: "Mexico", // Mexico
          NI: "Nicaragua", // Nicaragua
          PA: "Panama", // Panama
          PY: "Paraguay", // Paraguay
          PE: "Peru", // Peru
          KN: "Saint Kitts and Nevis", // Saint Kitts and Nevis
          LC: "Saint Lucia", // Saint Lucia
          VC: "Saint Vincent and the Grenadines", // Saint Vincent and the Grenadines
          SR: "Suriname", // Suriname
          TT: "Trinidad and Tobago", // Trinidad and Tobago
          UY: "Uruguay", // Uruguay
          VE: "Venezuela", // Venezuela
          // southeast_asia
          BN: "Brunei", // Brunei
          KH: "Cambodia", // Cambodia
          ID: "Indonesia", // Indonesia
          LA: "Laos", // Laos
          MY: "Malaysia", // Malaysia
          MM: "Myanmar", // Myanmar
          PH: "Philippines", // Philippines
          TH: "Thailand", // Thailand
          TL: "Timor-Leste", // Timor-Leste
          VN: "Vietnam", // Vietnam
          // africa (excluding South Africa)
          DZ: "Algeria", // Algeria
          AO: "Angola", // Angola
          BJ: "Benin", // Benin
          BW: "Botswana", // Botswana
          BF: "Burkina Faso", // Burkina Faso
          BI: "Burundi", // Burundi
          CV: "Cabo Verde", // Cabo Verde
          CM: "Cameroon", // Cameroon
          CF: "Central African Republic", // Central African Republic
          TD: "Chad", // Chad
          KM: "Comoros", // Comoros
          CG: "Congo", // Congo
          CD: "DR Congo", // DR Congo
          DJ: "Djibouti", // Djibouti
          EG: "Egypt", // Egypt
          GQ: "Equatorial Guinea", // Equatorial Guinea
          ER: "Eritrea", // Eritrea
          SZ: "Eswatini", // Eswatini
          ET: "Ethiopia", // Ethiopia
          GA: "Gabon", // Gabon
          GM: "Gambia", // Gambia
          GH: "Ghana", // Ghana
          GN: "Guinea", // Guinea
          GW: "Guinea-Bissau", // Guinea-Bissau
          CI: "Ivory Coast", // Ivory Coast
          KE: "Kenya", // Kenya
          LS: "Lesotho", // Lesotho
          LR: "Liberia", // Liberia
          LY: "Libya", // Libya
          MG: "Madagascar", // Madagascar
          MW: "Malawi", // Malawi
          ML: "Mali", // Mali
          MR: "Mauritania", // Mauritania
          MU: "Mauritius", // Mauritius
          MA: "Morocco", // Morocco
          MZ: "Mozambique", // Mozambique
          NA: "Namibia", // Namibia
          NE: "Niger", // Niger
          NG: "Nigeria", // Nigeria
          RW: "Rwanda", // Rwanda
          ST: "Sao Tome and Principe", // Sao Tome and Principe
          SN: "Senegal", // Senegal
          SC: "Seychelles", // Seychelles
          SL: "Sierra Leone", // Sierra Leone
          SO: "Somalia", // Somalia
          SS: "South Sudan", // South Sudan
          SD: "Sudan", // Sudan
          TG: "Togo", // Togo
          TN: "Tunisia", // Tunisia
          UG: "Uganda", // Uganda
          ZM: "Zambia", // Zambia
          ZW: "Zimbabwe", // Zimbabwe
          // middle_east
          BH: "Bahrain", // Bahrain
          IR: "Iran", // Iran
          IQ: "Iraq", // Iraq
          JO: "Jordan", // Jordan
          KW: "Kuwait", // Kuwait
          LB: "Lebanon", // Lebanon
          OM: "Oman", // Oman
          PS: "Palestine", // Palestine
          QA: "Qatar", // Qatar
          SA: "Saudi Arabia", // Saudi Arabia
          SY: "Syria", // Syria
          TR: "Turkey", // Turkey
          AE: "United Arab Emirates", // United Arab Emirates
          YE: "Yemen", // Yemen
          // eastern_europe (non-EU Eastern Europe)
          AL: "Albania", // Albania
          AM: "Armenia", // Armenia
          AZ: "Azerbaijan", // Azerbaijan
          BY: "Belarus", // Belarus
          BA: "Bosnia and Herzegovina", // Bosnia and Herzegovina
          GE: "eorgia", // Georgia
          XK: "Kosovo", // Kosovo
          MD: "Moldova", // Moldova
          ME: "Montenegro", // Montenegro
          MK: "North Macedonia", // North Macedonia
          RU: "Russia", // Russia
          RS: "Serbia", // Serbia
          UA: "Ukraine", // Ukraine
          // aus_nz
          AU: "Australia", // Australia
          NZ: "New Zealand", // New Zealand
          FJ: "Fiji", // Fiji
          KI: "Kiribati", // Kiribati
          MH: "Marshall Islands", // Marshall Islands
          FM: "Micronesia", // Micronesia
          NR: "Nauru", // Nauru
          PW: "Palau", // Palau
          PG: "Papua New Guinea", // Papua New Guinea
          WS: "Samoa", // Samoa
          SB: "Solomon Islands", // Solomon Islands
          TO: "Tonga", // Tonga
          TV: "Tuvalu", // Tuvalu
          VU: "Vanuatu", // Vanuatu
          // outliers
          JP: "Japan", // Japan
          KR: "South Korea", // South Korea
          IL: "Israel", // Israel
          SG: "Singapore", // Singapore
          // north_america
          US: "United States", // United States
          CA: "Canada", // Canada
          // eu (EU countries + UK)
          AT: "Austria", // Austria
          BE: "Belgium", // Belgium
          BG: "Bulgaria", // Bulgaria
          HR: "Croatia", // Croatia
          CY: "Cyprus", // Cyprus
          CZ: "Czech Republic", // Czech Republic
          DK: "Denmark", // Denmark
          EE: "Estonia", // Estonia
          FI: "Finland", // Finland
          FR: "France", // France
          DE: "Germany", // Germany
          GR: "Greece", // Greece
          HU: "Hungary", // Hungary
          IE: "Ireland", // Ireland
          IT: "Italy", // Italy
          LV: "Latvia", // Latvia
          LT: "Lithuania", // Lithuania
          LU: "Luxembourg", // Luxembourg
          MT: "Malta", // Malta
          NL: "Netherlands", // Netherlands
          PL: "Poland", // Poland
          PT: "Portugal", // Portugal
          RO: "Romania", // Romania
          SK: "Slovakia", // Slovakia
          SI: "Slovenia", // Slovenia
          ES: "Spain", // Spain
          SE: "Sweden", // Sweden
          GB: "United Kingdom", // United Kingdom
        },

        "accounted_title": "Accounted",
        "pending_title": "Pending",
        "accounted_total": 'Accounted Total',
        "pending_total": "Pending Total",
        starting_balance: "Trial period excess amount",
        tier: "Tier",
        unit: "Unit",
        contract: "Contract",
        sms: "SMS",
        bridge: "Bridge",
        at: "at",
        units: "units",
        infinity: "infinity",
        description: "Description",
        preparing_payment: "Preparing payment environment...",
    },
    zh: {
        "title": "支付",
        get_credit: "获取 $15 低佣金",
        bind_credit_card: "绑定信用卡即可立即获得 15 美元抵用金。",
        "phone_number_is_required": "需要填写电话号码",
        "phone_number_is_invalid": "电话号码无效",
        "email_is_required": "需要填写邮箱",
        "email_is_invalid": "邮箱无效",
        "verify_code_is_required": "需要填写验证码",
        "failed_to_create_payment_method": "创建支付方式失败",
        "failed_to_load_user_info": "加载用户信息失败",
        "failed_to_get_products": "获取产品失败",
        "failed_to_get_pending_items": "获取待处理项失败",
        "failed_to_create_customer_portal": "创建客户门户失败",
        "failed_to_subscribe_plan": "订阅计划失败",
        "send_verification_code": "发送验证码",
        "send": "发送",
        "input_verification_code": "输入验证码",
        "verify": "验证",
        "email": "邮箱",
        "name": "姓名",
        "credit_card": "信用卡",
        "subscribe": "订阅",
        "resume": "恢复订阅",
        "renew": "续订订阅",
        "loading_products": "加载产品中...",
        "products": "产品",
        "price_per_unit": "每单位价格",
        "loading_invoices": "加载发票中...",
        "invoices": "发票",
        "date": "日期",
        "amount": "金额",
        "quantity": "数量",
        "status": "状态",
        "paid": "已支付",
        "unpaid": "未支付",
        "payment_method": "支付方式",
        "invoice": "发票",
        "item": "项目",
        "download_invoice_pdf": "下载发票 PDF",
        "no_products": "无产品",
        "no_products_description": "没有可用的产品",
        "no_invoices": "无发票",
        "no_invoices_description": "没有可用的发票",
        failed_to_create_checkout_session: "创建结账会话失败",
        failed_to_generate_invoice: "生成发票失败",
        waiting_for_payment: "等待支付中...",
        "created_at": "创建时间：",
        "balance": "余额：",
        "total": "总计：",
        "remaining": "剩余：",
        "card_not_found": "未找到卡",
        "back": "返回",
        "next": "下一步",
        "close": "关闭",
        "cancel": "取消",
        "cancel_subscription": "取消订阅",
        "save": "保存",
        "check_payment_configuration": "检查支付配置",
        cancel_dialog: {
          title: "取消订阅确认",
          description: "取消订阅将使部分 PlexiMail 功能无法使用。您仍然要取消吗？",
          confirm_label: "",
          confirm_checkbox: "我理解取消订阅将使部分 PlexiMail 功能无法使用。",
          back: "返回",
          cancel: "是的，取消"
        },
        add_payment_dialog: {
          title: "添加支付方式",
          description: {
            line1: "试用额度用完后，如需继续使用 PlexiSign，请添加有效的付款方式。",
            line2: "PlexiSign.net 将通过您的付款方式收取上个月的任何账单金额。",
            line3: "如果没有产生任何费用，则不会产生账单。"
          },
          add_now: "现在添加",
          add_later: "稍后添加",
        },
        subscribe_title: "PlexiSign",
        auto_renew_title: "自动续订",
        auto_renew_description: "在计费周期结束时自动续订您的订阅。",
        cancelled_description: "您的订阅将在计费周期结束时被取消。",
        payment_title: "支付",
        manage: "管理",
        loading_subscription: "加载订阅中...",
        check_payment_config: "检查订阅状态...",
        verify_phone_number: "验证电话号码",
        create_customer: "添加支付方式",
        create_subscription: "订阅 PlexiSign",
        manage_subscription: "管理订阅",
        manage_payment: "管理支付",
        view_invoice_history: "查看发票历史",
        view_invoice: "查看发票详情",
        invoice_preview: "发票预览",
        update: "更新",
        save_updates: "保存更新",
        prices: "价格",
        usage_for_billing_cycle: "当前计费周期使用情况",
        usage_for_trail_user: "试用用户使用情况",
        loading_usage: "加载使用情况...",
        usage: "使用情况",
        regionNameMap: {
          east_asia: "东亚",
          south_asia: "东南亚",
          latin_america: "拉美",
          southeast_asia: "东南亚",
          africa: "非洲（不含南非）",
          middle_east: "中东",
          eastern_europe: "东欧（非欧盟东欧）",
          aus_nz: "澳大利亚和新西兰",
          outliers: "离群值",
          north_america: "北美洲",
          eu: "欧盟（欧盟国家 + 英国）"
        },
        countryNameMap: {
          // east_asia
          CN: "中国", // China
          TW: "台湾", // Taiwan
          // south_asia
          AF: "阿富汗", // Afghanistan
          BD: "孟加拉国", // Bangladesh
          BT: "不丹", // Bhutan
          IN: "印度", // India
          MV: "马尔代夫", // Maldives
          NP: "尼泊尔", // Nepal
          PK: "巴基斯坦", // Pakistan
          LK: "斯里兰卡", // Sri Lanka
          // latin_america
          AR: "阿根廷", // Argentina
          BS: "巴哈马", // Bahamas
          BB: "巴巴多斯", // Barbados
          BZ: "伯利兹", // Belize
          BO: "玻利维亚", // Bolivia
          BR: "巴西", // Brazil
          CL: "智利", // Chile
          CO: "哥伦比亚", // Colombia
          CR: "哥斯达黎加", // Costa Rica
          CU: "古巴", // Cuba
          DM: "多米尼克", // Dominica
          DO: "多米尼加共和国", // Dominican Republic
          EC: "厄瓜多尔", // Ecuador
          SV: "萨尔瓦多", // El Salvador
          GD: "格林纳达", // Grenada
          GT: "危地马拉", // Guatemala
          GY: "圭亚那", // Guyana
          HT: "海地", // Haiti
          HN: "洪都拉斯", // Honduras
          JM: "牙买加", // Jamaica
          MX: "墨西哥", // Mexico
          NI: "尼加拉瓜", // Nicaragua
          PA: "巴拿马", // Panama
          PY: "巴拉圭", // Paraguay
          PE: "秘鲁", // Peru
          KN: "圣基茨和尼维斯", // Saint Kitts and Nevis
          LC: "圣卢西亚", // Saint Lucia
          VC: "圣文森特和格林纳丁斯", // Saint Vincent and the Grenadines
          SR: "苏里南", // Suriname
          TT: "特立尼达和多巴哥", // Trinidad and Tobago
          UY: "乌拉圭", // Uruguay
          VE: "委内瑞拉", // Venezuela
          // southeast_asia
          BN: "文莱", // Brunei
          KH: "柬埔寨", // Cambodia
          ID: "印度尼西亚", // Indonesia
          LA: "老挝", // Laos
          MY: "马来西亚", // Malaysia
          MM: "缅甸", // Myanmar
          PH: "菲律宾", // Philippines
          TH: "泰国", // Thailand
          TL: "东帝汶", // Timor-Leste
          VN: "越南", // Vietnam
          // africa (excluding South Africa)
          DZ: "阿尔及利亚", // Algeria
          AO: "安哥拉", // Angola
          BJ: "贝宁", // Benin
          BW: "博茨瓦纳", // Botswana
          BF: "布基纳法索", // Burkina Faso
          BI: "布隆迪", // Burundi
          CV: "佛得角", // Cabo Verde
          CM: "喀麦隆", // Cameroon
          CF: "中非共和国", // Central African Republic
          TD: "乍得", // Chad
          KM: "科摩罗", // Comoros
          CG: "刚果", // Congo
          CD: "刚果民主共和国", // DR Congo
          DJ: "吉布提", // Djibouti
          EG: "埃及", // Egypt
          GQ: "赤道几内亚", // Equatorial Guinea
          ER: "厄立特里亚", // Eritrea
          SZ: "斯威士兰", // Eswatini
          ET: "埃塞俄比亚", // Ethiopia
          GA: "加蓬", // Gabon
          GM: "冈比亚", // Gambia
          GH: "加纳", // Ghana
          GN: "几内亚", // Guinea
          GW: "几内亚比绍", // Guinea-Bissau
          CI: "科特迪瓦", // Ivory Coast
          KE: "肯尼亚", // Kenya
          LS: "莱索托", // Lesotho
          LR: "利比里亚", // Liberia
          LY: "利比亚", // Libya
          MG: "马达加斯加", // Madagascar
          MW: "马拉维", // Malawi
          ML: "马里", // Mali
          MR: "毛里塔尼亚", // Mauritania
          MU: "毛里求斯", // Mauritius
          MA: "摩洛哥", // Morocco
          MZ: "莫桑比克", // Mozambique
          NA: "纳米比亚", // Namibia
          NE: "尼日尔", // Niger
          NG: "尼日利亚", // Nigeria
          RW: "卢旺达", // Rwanda
          ST: "圣多美和普林西比", // Sao Tome and Principe
          SN: "塞内加尔", // Senegal
          SC: "塞舌尔", // Seychelles
          SL: "塞拉利昂", // Sierra Leone
          SO: "索马里", // Somalia
          SS: "南苏丹", // South Sudan
          SD: "苏丹", // Sudan
          TG: "多哥", // Togo
          TN: "突尼斯", // Tunisia
          UG: "乌干达", // Uganda
          ZM: "赞比亚", // Zambia
          ZW: "津巴布韦", // Zimbabwe
          // middle_east
          BH: "巴林", // Bahrain
          IR: "伊朗", // Iran
          IQ: "伊拉克", // Iraq
          JO: "约旦", // Jordan
          KW: "科威特", // Kuwait
          LB: "黎巴嫩", // Lebanon
          OM: "阿曼", // Oman
          PS: "巴勒斯坦", // Palestine
          QA: "卡塔尔", // Qatar
          SA: "沙特阿拉伯", // Saudi Arabia
          SY: "叙利亚", // Syria
          TR: "土耳其", // Turkey
          AE: "阿拉伯联合酋长国", // United Arab Emirates
          YE: "也门", // Yemen
          // eastern_europe (non-EU Eastern Europe)
          AL: "阿尔巴尼亚", // Albania
          AM: "亚美尼亚", // Armenia
          AZ: "阿塞拜疆", // Azerbaijan
          BY: "白俄罗斯", // Belarus
          BA: "波斯尼亚和黑塞哥维那", // Bosnia and Herzegovina
          GE: "格鲁吉亚", // Georgia
          XK: "科索沃", // Kosovo
          MD: "摩尔多瓦", // Moldova
          ME: "黑山", // Montenegro
          MK: "北马其顿", // North Macedonia
          RU: "俄罗斯", // Russia
          RS: "塞尔维亚", // Serbia
          UA: "乌克兰", // Ukraine
          // aus_nz
          AU: "澳大利亚", // Australia
          NZ: "新西兰", // New Zealand
          FJ: "斐济", // Fiji
          KI: "基里巴斯", // Kiribati
          MH: "马绍尔群岛", // Marshall Islands
          FM: "密克罗尼西亚", // Micronesia
          NR: "瑙鲁", // Nauru
          PW: "帕劳", // Palau
          PG: "巴布亚新几内亚", // Papua New Guinea
          WS: "萨摩亚", // Samoa
          SB: "所罗门群岛", // Solomon Islands
          TO: "汤加", // Tonga
          TV: "图瓦卢", // Tuvalu
          VU: "瓦努阿图", // Vanuatu
          // outliers
          JP: "日本", // Japan
          KR: "韩国", // South Korea
          IL: "以色列", // Israel
          SG: "新加坡", // Singapore
          // north_america
          US: "美国", // United States
          CA: "加拿大", // Canada
          // eu (EU countries + UK)
          AT: "奥地利", // Austria
          BE: "比利时", // Belgium
          BG: "保加利亚", // Bulgaria
          HR: "克罗地亚", // Croatia
          CY: "塞浦路斯", // Cyprus
          CZ: "捷克共和国", // Czech Republic
          DK: "丹麦", // Denmark
          EE: "爱沙尼亚", // Estonia
          FI: "芬兰", // Finland
          FR: "法国", // France
          DE: "德国", // Germany
          GR: "希腊", // Greece
          HU: "匈牙利", // Hungary
          IE: "爱尔兰", // Ireland
          IT: "意大利", // Italy
          LV: "拉脱维亚", // Latvia
          LT: "立陶宛", // Lithuania
          LU: "卢森堡", // Luxembourg
          MT: "马耳他", // Malta
          NL: "荷兰", // Netherlands
          PL: "波兰", // Poland
          PT: "葡萄牙", // Portugal
          RO: "罗马尼亚", // Romania
          SK: "斯洛伐克", // Slovakia
          SI: "斯洛文尼亚", // Slovenia
          ES: "西班牙", // Spain
          SE: "瑞典", // Sweden
          GB: "英国", // United Kingdom
        },
        "accounted_title": "已入账",
        "pending_title": "未入账",
        "accounted_total": '已入账汇总',
        "pending_total": "未入账汇总",
        starting_balance: "试用期超额金额",
        tier: "层级",
        unit: "单位",
        contract: "合同",
        sms: "短信",
        bridge: "桥接",
        at: "",
        units: "单位",
        infinity: "无限",
        description: "描述",
        preparing_payment: "正在准备支付环境...",
      },
      es: {
        "title": "Pago",
        get_credit: "Obtén $15 de crédito",
        bind_credit_card: "Obtén $15 de crédito al instante vinculando tu tarjeta de crédito.",
        "phone_number_is_required": "Se requiere un número de teléfono",
        "phone_number_is_invalid": "El número de teléfono no es válido",
        "email_is_required": "Se requiere un correo electrónico",
        "email_is_invalid": "El correo electrónico no es válido",
        "verify_code_is_required": "Se requiere un código de verificación",
        "failed_to_create_payment_method": "No se pudo crear el método de pago",
        "failed_to_load_user_info": "No se pudo cargar la información del usuario",
        "failed_to_get_pending_items": "No se pudieron obtener los artículos pendientes",
        "failed_to_create_customer_portal": "No se pudo crear el portal del cliente",
        "failed_to_get_products": "No se pudieron obtener los productos",
        "failed_to_subscribe_plan": "No se pudo suscribir al plan",
        "send_verification_code": "Enviar código de verificación",
        "send": "Enviar",
        "input_verification_code": "Ingresar código de verificación",
        "verify": "Verificar",
        "email": "Correo electrónico",
        "name": "Nombre",
        "credit_card": "Tarjeta de crédito",
        "subscribe": "Suscribirse",
        "resume": "Reanudar suscripción",
        "renew": "Renovar suscripción",
        "loading_products": "Cargando productos...",
        "products": "Productos",
        "price_per_unit": "Precio por unidad",
        "loading_invoices": "Cargando facturas...",
        "invoices": "Facturas",
        "date": "Fecha",
        "amount": "Monto",
        "quantity": "Cantidad",
        "status": "Estado",
        "paid": "Pagado",
        "unpaid": "No pagado",
        "payment_method": "Método de pago",
        "invoice": "Factura",
        "item": "Artículo",
        "download_invoice_pdf": "Descargar factura en PDF",
        "no_products": "Sin productos",
        "no_products_description": "No hay productos disponibles",
        "no_invoices": "Sin facturas",
        "no_invoices_description": "No hay facturas disponibles",
        failed_to_create_checkout_session: "Error al crear la sesión de pago",
        failed_to_generate_invoice: "Error al generar la factura",
        waiting_for_payment: "Esperando pago...",
        "created_at": "Creado el: ",
        "balance": "Saldo: ",
        "total": "Total: ",
        "remaining": "Restante: ",
        "card_not_found": "Tarjeta no encontrada",
        "back": "Volver",
        "next": "Siguiente",
        "close": "Cerrar",
        "cancel": "Cancelar",
        "cancel_subscription": "Cancelar suscripción",
        "save": "Guardar",
        "check_payment_configuration": "Verificar configuración de pago",
        cancel_dialog: {
          title: "Confirmación de cancelación de suscripción",
          description: "Cancelar la suscripción solo hará que algunas funciones de PlexiMail no estén disponibles. ¿Estás seguro de que deseas cancelar?",
          confirm_label: "",
          confirm_checkbox: "Soy consciente de que cancelar mi suscripción hará que algunas funciones de PlexiMail no estén disponibles.",
          back: "Volver",
          cancel: "Sí, cancelar"
        },
        add_payment_dialog: {
          title: "Agregar método de pago",
          description: {
            line1: "Para utilizar PlexiMail, debe agregar un método de pago.",
            line2: "PlexiSign.net cobrará mensualmente a través de su tarjeta de crédito.",
            line3: "Si no se produce ningún cargo, no se emitirá ninguna factura."
          },
          add_now: "Agregar ahora",
          add_later: "Agregar más tarde",
        },
        subscribe_title: "PlexiSign",
        auto_renew_title: "Renovación automática",
        auto_renew_description: "Renovar automáticamente su suscripción al final del ciclo de facturación.",
        cancelled_description: "Su suscripción se cancelará al final del ciclo de facturación.",
        payment_title: "Pago",
        manage: "Administrar",
        loading_subscription: "Cargando suscripción...",
        check_payment_config: "Verificar estado de pago...",
        verify_phone_number: "Verificar número de teléfono",
        create_customer: "Agregar método de pago",
        create_subscription: "Suscribirse a PlexiSign",
        manage_subscription: "Administrar suscripción",
        manage_payment: "Administrar pago",
        view_invoice_history: "Ver historial de facturas",
        view_invoice: "Ver detalles de factura",
        invoice_preview: "Vista previa de factura",
        update: "Actualizar",
        save_updates: "Guardar cambios",
        prices: "Precios",
        usage_for_billing_cycle: "Uso para el ciclo de facturación actual",
        usage_for_trail_user: "Uso para usuario de prueba",
        loading_usage: "Cargando uso...",
        usage: "Uso",
        regionNameMap: {
          east_asia: "Asia Oriental",
          south_asia: "Asia Sudeste",
          latin_america: "América Latina",
          southeast_asia: "Asia Sudeste",
          africa: "África (excluyendo Sudáfrica)",
          middle_east: "Medio Oriente",
          eastern_europe: "Europa Oriental (no Europa Oriental)",
          aus_nz: "Australia y Nueva Zelanda",
          outliers: "Outliers",
          north_america: "Norteamérica",
          eu: "EU (EU countries + UK)"
        },
      },
      countryNameMap: {
        // east_asia
        CN: "China", // China
        TW: "Taiwán", // Taiwan
        // south_asia
        AF: "Afganistán", // Afghanistan
        BD: "Bangladés", // Bangladesh
        BT: "Bután", // Bhutan
        IN: "India", // India
        MV: "Maldivas", // Maldives
        NP: "Nepal", // Nepal
        PK: "Pakistán", // Pakistan
        LK: "Sri Lanka", // Sri Lanka
        // latin_america
        AR: "Argentina", // Argentina
        BS: "Bahamas", // Bahamas
        BB: "Barbados", // Barbados
        BZ: "Belice", // Belize
        BO: "Bolivia", // Bolivia
        BR: "Brasil", // Brazil
        CL: "Chile", // Chile
        CO: "Colombia", // Colombia
        CR: "Costa Rica", // Costa Rica
        CU: "Cuba", // Cuba
        DM: "Dominica", // Dominica
        DO: "República Dominicana", // Dominican Republic
        EC: "Ecuador", // Ecuador
        SV: "El Salvador", // El Salvador
        GD: "Granada", // Grenada
        GT: "Guatemala", // Guatemala
        GY: "Guyana", // Guyana
        HT: "Haití", // Haiti
        HN: "Honduras", // Honduras
        JM: "Jamaica", // Jamaica
        MX: "México", // Mexico
        NI: "Nicaragua", // Nicaragua
        PA: "Panamá", // Panama
        PY: "Paraguay", // Paraguay
        PE: "Perú", // Peru
        KN: "San Cristóbal y Nieves", // Saint Kitts and Nevis
        LC: "Santa Lucía", // Saint Lucia
        VC: "San Vicente y las Granadinas", // Saint Vincent and the Grenadines
        SR: "Surinam", // Suriname
        TT: "Trinidad y Tobago", // Trinidad and Tobago
        UY: "Uruguay", // Uruguay
        VE: "Venezuela", // Venezuela
        // southeast_asia
        BN: "Brunéi", // Brunei
        KH: "Camboya", // Cambodia
        ID: "Indonesia", // Indonesia
        LA: "Laos", // Laos
        MY: "Malasia", // Malaysia
        MM: "Myanmar", // Myanmar
        PH: "Filipinas", // Philippines
        TH: "Tailandia", // Thailand
        TL: "Timor Oriental", // Timor-Leste
        VN: "Vietnam", // Vietnam
        // africa (excluding South Africa)
        DZ: "Argelia", // Algeria
        AO: "Angola", // Angola
        BJ: "Benín", // Benin
        BW: "Botsuana", // Botswana
        BF: "Burkina Faso", // Burkina Faso
        BI: "Burundi", // Burundi
        CV: "Cabo Verde", // Cabo Verde
        CM: "Camerún", // Cameroon
        CF: "República Centroafricana", // Central African Republic
        TD: "Chad", // Chad
        KM: "Comoras", // Comoros
        CG: "Congo", // Congo
        CD: "República Democrática del Congo", // DR Congo
        DJ: "Yibuti", // Djibouti
        EG: "Egipto", // Egypt
        GQ: "Guinea Ecuatorial", // Equatorial Guinea
        ER: "Eritrea", // Eritrea
        SZ: "Esuatini", // Eswatini
        ET: "Etiopía", // Ethiopia
        GA: "Gabón", // Gabon
        GM: "Gambia", // Gambia
        GH: "Ghana", // Ghana
        GN: "Guinea", // Guinea
        GW: "Guinea-Bisáu", // Guinea-Bissau
        CI: "Costa de Marfil", // Ivory Coast
        KE: "Kenia", // Kenya
        LS: "Lesoto", // Lesotho
        LR: "Liberia", // Liberia
        LY: "Libia", // Libya
        MG: "Madagascar", // Madagascar
        MW: "Malaui", // Malawi
        ML: "Malí", // Mali
        MR: "Mauritania", // Mauritania
        MU: "Mauricio", // Mauritius
        MA: "Marruecos", // Morocco
        MZ: "Mozambique", // Mozambique
        NA: "Namibia", // Namibia
        NE: "Níger", // Niger
        NG: "Nigeria", // Nigeria
        RW: "Ruanda", // Rwanda
        ST: "Santo Tomé y Príncipe", // Sao Tome and Principe
        SN: "Senegal", // Senegal
        SC: "Seychelles", // Seychelles
        SL: "Sierra Leona", // Sierra Leone
        SO: "Somalia", // Somalia
        SS: "Sudán del Sur", // South Sudan
        SD: "Sudán", // Sudan
        TG: "Togo", // Togo
        TN: "Túnez", // Tunisia
        UG: "Uganda", // Uganda
        ZM: "Zambia", // Zambia
        ZW: "Zimbabue", // Zimbabwe
        // middle_east
        BH: "Baréin", // Bahrain
        IR: "Irán", // Iran
        IQ: "Irak", // Iraq
        JO: "Jordania", // Jordan
        KW: "Kuwait", // Kuwait
        LB: "Líbano", // Lebanon
        OM: "Omán", // Oman
        PS: "Palestina", // Palestine
        QA: "Catar", // Qatar
        SA: "Arabia Saudita", // Saudi Arabia
        SY: "Siria", // Syria
        TR: "Turquía", // Turkey
        AE: "Emiratos Árabes Unidos", // United Arab Emirates
        YE: "Yemen", // Yemen
        // eastern_europe (non-EU Eastern Europe)
        AL: "Albania", // Albania
        AM: "Armenia", // Armenia
        AZ: "Azerbaiyán", // Azerbaijan
        BY: "Bielorrusia", // Belarus
        BA: "Bosnia y Herzegovina", // Bosnia and Herzegovina
        GE: "Georgia", // Georgia
        XK: "Kosovo", // Kosovo
        MD: "Moldavia", // Moldova
        ME: "Montenegro", // Montenegro
        MK: "Macedonia del Norte", // North Macedonia
        RU: "Rusia", // Russia
        RS: "Serbia", // Serbia
        UA: "Ucrania", // Ukraine
        // aus_nz
        AU: "Australia", // Australia
        NZ: "Nueva Zelanda", // New Zealand
        FJ: "Fiyi", // Fiji
        KI: "Kiribati", // Kiribati
        MH: "Islas Marshall", // Marshall Islands
        FM: "Micronesia", // Micronesia
        NR: "Nauru", // Nauru
        PW: "Palaos", // Palau
        PG: "Papúa Nueva Guinea", // Papua New Guinea
        WS: "Samoa", // Samoa
        SB: "Islas Salomón", // Solomon Islands
        TO: "Tonga", // Tonga
        TV: "Tuvalu", // Tuvalu
        VU: "Vanuatu", // Vanuatu
        // outliers
        JP: "Japón", // Japan
        KR: "Corea del Sur", // South Korea
        IL: "Israel", // Israel
        SG: "Singapur", // Singapore
        // north_america
        US: "Estados Unidos", // United States
        CA: "Canadá", // Canada
        // eu (EU countries + UK)
        AT: "Austria", // Austria
        BE: "Bélgica", // Belgium
        BG: "Bulgaria", // Bulgaria
        HR: "Croacia", // Croatia
        CY: "Chipre", // Cyprus
        CZ: "República Checa", // Czech Republic
        DK: "Dinamarca", // Denmark
        EE: "Estonia", // Estonia
        FI: "Finlandia", // Finland
        FR: "Francia", // France
        DE: "Alemania", // Germany
        GR: "Grecia", // Greece
        HU: "Hungría", // Hungary
        IE: "Irlanda", // Ireland
        IT: "Italia", // Italy
        LV: "Letonia", // Latvia
        LT: "Lituania", // Lithuania
        LU: "Luxemburgo", // Luxembourg
        MT: "Malta", // Malta
        NL: "Países Bajos", // Netherlands
        PL: "Polonia", // Poland
        PT: "Portugal", // Portugal
        RO: "Rumanía", // Romania
        SK: "Eslovaquia", // Slovakia
        SI: "Eslovenia", // Slovenia
        ES: "España", // Spain
        SE: "Suecia", // Sweden
        GB: "Reino Unido", // United Kingdom
      },

      "accounted_title": "Contabilizada",
      "pending_title": "Pendiente",
      "accounted_total": 'Total contabilizada',
      "pending_total": "Total Pendiente",
      starting_balance: "Monto excedente del período de prueba",
      tier: "Nivel",
      unit: "Unidad",
      contract: "Contrato",
      sms: "SMS",
      email: "Email",
      bridge: "Bridge",
      at: "a",
      units: "Unidades",
      infinity: "Infinto",
      description: "Descripcion",
      preparing_payment: "Preparando pago...",
  });
  window.paymentLocalizedStrings = localizedStrings;
}

const detectLanguage = () => {
  const lang = navigator.language;
//   console.log("detectLanguage:", lang);
  if (lang.startsWith("zh")) {
    return "zh";
  } else if (lang.startsWith("en")) {
    return "en";
  } else if (lang.startsWith("es")) {
    return "es";
  } else {
    return "en";
  }
};

let lang = localStorage.getItem("language");
if (!lang || lang === "") {
  lang = detectLanguage();
}

if (lang !== "en" && lang !== "zh" && lang !== "es") {
  lang = "en";
}

window.paymentLocalizedStrings.setLanguage(lang);

// window.localizedStrings.setLanguage("es");
const PaymentStrings = window.paymentLocalizedStrings;
export default PaymentStrings;
